import React, { forwardRef, ReactNode } from 'react';
import { List as ChakraList, ListProps } from '@chakra-ui/react';

interface Props extends Omit<ListProps, `css`> {
  children: ReactNode;
}

export const List = forwardRef<HTMLUListElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraList ref={ref} {...props}>
        {children}
      </ChakraList>
    );
  }
);
export type { Props as ListProps };
